<nav app-navigation-sidebar class="navbar navbar-vertical fixed-start navbar-expand-md navbar-light" id="sidebar"></nav>
<div class="internal-content-wrapper main-content">
  <router-outlet></router-outlet>
</div>
